import { app } from '../../../app';

app.run(init);

/** @ngInject */
function init($q, $rootScope, $state, $transitions, $translate) {

    const history = $rootScope.breadcrumbHistory = [];

    const setBreadcrumbs = () => {

        if (!$rootScope.transition) {
            return;
        }

        const promises = $rootScope.transition.treeChanges().to
            .map(({resolvables, state}) => {
                const resolvable = resolvables.find(({token}) => token === '$breadcrumbs');
                const breadcrumbs = (resolvable || {}).data || [{}];
                return breadcrumbs.map((breadcrumb) => ({...breadcrumb, state}));
            })
            .reduce((a, b) => [...a, ...b])
            .map(({state, stateName, stateParams, title, vars}) => {
                const href = stateName ? $state.href(stateName, stateParams) : $state.href(state);
                const name = stateName || state.name;
                return $q.resolve(title || $translate(`${name}.$title`, vars))
                    .then(title => ({href, name, title}))
                    .catch(() => ({}));
            });

        $q.all(promises)
            .then(breadcrumbs => breadcrumbs.filter(({title}) => title))
            .then(breadcrumbs => {
                $rootScope.breadcrumbs = breadcrumbs;

                setTimeout(() => document.title =
                    breadcrumbs.map(b => b.title).reverse().concat('SAASPASS').join(' - ')
                );

                const breadcrumb = breadcrumbs.slice(-1)[0] || {};
                $rootScope.stateTitle = breadcrumb.title;
                history.push(breadcrumb);
                history.length > 100 && history.splice(0, 50);
            })
    };

    $transitions.onSuccess({}, setBreadcrumbs);
    $rootScope.$on('breadcrumb-data-changed', setBreadcrumbs);
    $rootScope.$on('language-loaded', setBreadcrumbs);
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-header/sp-breadcrumbs/sp-breadcrumbs.init.js